import { createIcon } from "@chakra-ui/icons";

export const RowUngroupIcon = createIcon({
  displayName: "RowUngroupIcon",
  viewBox: "0 0 16 16",
  defaultProps: {
    width: "16px",
    height: "16px",
  },
  path: (
    <>
      <path
        d="M5.16129 6.91583H2.06452C1.49442 6.91583 1.03226 7.37799 1.03226 7.94809V14.1416C1.03226 14.7117 1.49442 15.1739 2.06452 15.1739H8.25806C8.82816 15.1739 9.29032 14.7117 9.29032 14.1416V11.3548H8.00006V13.8833H2.32264V8.20585H5.16129V6.91583Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74194 1.03226H13.9355C14.5056 1.03226 14.9677 1.49442 14.9677 2.06452V8.25806C14.9677 8.82816 14.5056 9.29032 13.9355 9.29032H7.74194C7.17184 9.29032 6.70968 8.82816 6.70968 8.25806V2.06452C6.70968 1.49442 7.17184 1.03226 7.74194 1.03226ZM13.6775 2.32238H8.00006V7.9998H13.6775V2.32238Z"
        fill="currentColor"
      />
    </>
  ),
});
